<template>
  <section>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab" type="default-scroll"></tabs>
        </div>
      </div>
    </section>
    <!-- hot tracker -->
    <tracking-v2 v-if="currentTab === 'trackingv2'"></tracking-v2>
    <!-- retro alimetação -->
    <populate-pixel v-if="currentTab === 'populate-pixel'"></populate-pixel>
    <!-- manager pixel -->
    <manager-pixel v-if="currentTab === 'manager-pixel'"></manager-pixel>
    <!-- whatspp -->
    <whats v-if="currentTab === 'whatsapp'"></whats>

    <dash-tax-tracker v-if="currentTab === 'taxtracker'"></dash-tax-tracker>
    <!-- page ignore -->
    <page-ignore v-if="currentTab === 'page-ignore'"></page-ignore>
    <!-- domains -->
    <domain v-if="currentTab === 'domain'"></domain>
    <!-- domains -->
    <custom-conversion v-if="currentTab === 'custom-conver'"></custom-conversion>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";

import DashTaxTracker from "@/modules/trackingV2/DashTaxTracker";
import TrackingV2 from "@/modules/trackingV2/TrackingV2";
import PopulatePixel from "@/modules/populatePixel/PopulatePixel";
import ManagerPixel from "@/modules/populatePixel/ManagerPixel";
import Whats from "@/modules/trackingV2/Whats";
import PageIgnore from "@/modules/trackingV2/PageIgnore";
import Domain from "@/modules/trackingV2/Domain";
import CustomConversion from "@/modules/customconversion/CustomConversion";

export default {
  name: "dash-detail",
  components: {
    Tabs,
    DashTaxTracker,
    PopulatePixel,
    ManagerPixel,
    TrackingV2,
    PageIgnore,
    Whats,
    Domain,
    CustomConversion
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      currentTab: "utms",
      reportTabs: [
        {
          name: "trackingv2",
          title: "Hot Tracker (Pixel)",
        },
        {
          name: "custom-conver",
          title: "Conversões Personalizadas",
        },
        {
          name: "populate-pixel",
          title: "Retro Alimentação (I.A)",
        },
        
        {
          name: "manager-pixel",
          title: "Tags / Pixels",
        },
        {
          name: "domain",
          title: "Dominios",
        },
        {
          name: "taxtracker",
          title: "Taxa de Tracker",
        },
        {
          name: "whatsapp",
          title: "WhatsApps",
        },
      ],
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      } 
    },
    currentTab() {
      if (this.slug === this.currentTab) {
        return
      }
      this.$router.push({ name: "Track", params: { slug: this.currentTab } });
    }
  }

};
</script>

<style lang="scss" scoped></style>
